// Fuel Type Constants for FusionCab - Backend Compatible

export const FUEL_TYPES = {
  PETROL: "Petrol",
  DIESEL: "Diesel",
  CNG: "CNG",
  ANY: "any",
} as const;

export type FuelType = (typeof FUEL_TYPES)[keyof typeof FUEL_TYPES];

// User-facing filter options (excludes "any", which is a payload default, not a filter choice)
export const FUEL_TYPE_OPTIONS: { value: Exclude<FuelType, "any">; label: string }[] = [
  { value: FUEL_TYPES.PETROL, label: "Petrol" },
  { value: FUEL_TYPES.DIESEL, label: "Diesel" },
  { value: FUEL_TYPES.CNG, label: "CNG" },
];
